import api from './api'

export const notificacionService = {
  // Listar notificaciones del usuario autenticado
  async getAll(params = {}) {
    const response = await api.get('/notificaciones', { params })
    return response.data
  },

  // Obtener notificación específica
  async getById(id) {
    const response = await api.get(`/notificaciones/${id}`)
    return response.data
  },

  // Obtener contador de notificaciones no leídas
  async getContadorNoLeidas() {
    const response = await api.get('/notificaciones/contador')
    return response.data
  },

  // Marcar notificación como leída
  async marcarLeida(id) {
    const response = await api.post(`/notificaciones/${id}/marcar-leida`)
    return response.data
  },

  // Marcar todas las notificaciones como leídas
  async marcarTodasLeidas() {
    const response = await api.post('/notificaciones/marcar-todas-leidas')
    return response.data
  },

  // Ocultar todas las notificaciones (soft delete)
  async deleteSoftAll() {
    const response = await api.post('/notificaciones/ocultar-todas')
    return response.data
  },

  // Eliminar notificación (borrado duro; si el backend usa soft delete aquí, seguirá siendo la misma URL)
  async delete(id) {
    const response = await api.delete(`/notificaciones/${id}`)
    return response.data
  },

  // Ocultar / archivar notificación (soft delete).
  async deleteSoft(id) {
    const response = await api.patch(`/notificaciones/${id}/ocultar`)
    return response.data
  },
}

